





























































































	import { Component, Vue, Ref, Prop, Inject, Mixins } from 'vue-property-decorator';
	import { getOutFormConfig, addOutForm, wxApi } from '@/apis/user'
  import common from '../sheet/formPublic/common'
	import { uuid } from '@/utils/common'
	import { Toast } from 'vant'
	@Component({
		name: 'outForm'
	})
	export default class OutForm extends Mixins(common) {
		public submiType: any = ''
		public priorityAuthorityMap = {}
		public outFormObject = {
			outFormName: '',
			qrcodeUrl: '',
			tipContent: '',
			deviceId: '',
			sourceId: '',
			outFormId: '',
			worksheetId: ''
		}
		public sheetFieldList = [] as any[]
		public isAdmin = true
		public processId = false
		private handleWXJump () {
			// let a = 'https://cep-test.7moor.com/outForm?companyId=736&worksheetId=60c95f237ff3bf661ceb1041&outFormId=60e3bc0f112a1559689e0dff&source=2%0A&code=071RY9Ga1IBqiC05wsHa1PQCKS3RY9G7&state='
			const REDIRECT_URI = encodeURIComponent(window.location.origin + this.$route.fullPath);
			window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$route.query.appId}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base#wechat_redirect`
		}
		private async handleData (openid?: string) {
			if (this.$route.query) {
				if (this.$route.query.type) {
					this.submiType = this.$route.query.type
					this.outFormObject.qrcodeUrl = window.sessionStorage.getItem('qrcodeUrl') || ''
					this.outFormObject.tipContent = window.sessionStorage.getItem('qrcodeContent') || ''
				} else {
					const { worksheetId, outFormId, companyId, source } = this.$route.query as any
					this.outFormObject.outFormId = outFormId
					this.outFormObject.worksheetId = worksheetId
					window.sessionStorage.setItem('outFormObj', JSON.stringify(this.$route.query))
					window.sessionStorage.setItem('logincompanyid', companyId)
					let req1 = await getOutFormConfig ({ worksheetId, outFormId: this.outFormObject.outFormId })
					if (req1.success) {
						if (req1.data) {
							this.submiType = '-1'
							this.sheetFieldList = req1.data.fieldList
							this.outFormObject.outFormName = req1.data.outFormName
							this.outFormObject.sourceId = req1.data.source.businessId
							this.outFormObject.deviceId = req1.data.device.businessId
							let obj = {}
							this.sheetFieldList.map(item => {
								if (item.alias === 'openId') {
									obj[item.businessId] = openid
								} 
								if (item.alias === 'appId') {
									obj[item.businessId] = this.$route.query.appId
								}
							})
							this.initForm(null, obj)
						} else {
							this.submiType = '5'
						}
					}
				}
			}
		}
		private async mounted() {
		if (this.$route.query) {
      if (this.$route.query.code) {
        let url = `/sns/oauth2/access_token?appid=${this.$route.query.appId}&secret=${this.$route.query.appSecret}&code=${this.$route.query.code}&grant_type=authorization_code`
				let res = await wxApi(url)
        if (res.openid) {
          this.handleData(res.openid)
        }
      } else if (this.$route.query.appId) {
        this.handleWXJump()
        return
      } else {
        this.handleData()
      }
    }
	}
		private submitOutForm () {
			let form = this.$refs.form as any
			let p1 = form.validate()
			p1.then(async () => {
				const { outFormId, source } = this.$route.query as any
				const params = Object.assign({}, { data: this.form, outFormId })
				params.data[this.outFormObject.sourceId] = Number(source)
				params.data[this.outFormObject.deviceId] = window.localStorage.getItem('deviceId') || uuid()
				let res = await addOutForm (params)
				if (res.success) {
					window.localStorage.setItem('deviceId', params.data[this.outFormObject.deviceId])
					const { successResult }  = res.data
					this.submiType = successResult.type + ''
					if (successResult) {
						if (successResult.type !== 3) {
							console.log(history)
							this.outFormObject.tipContent = successResult.content || successResult.tip
							this.outFormObject.qrcodeUrl = successResult.qrCodeUrl || ''
							if (successResult.type === 2) {
								window.sessionStorage.setItem('qrcodeUrl', successResult.qrCodeUrl)
								window.sessionStorage.setItem('qrcodeContent', successResult.content || successResult.tip)
							}
							this.$router.push({ path: '/outForm', query: { type: this.submiType, worksheetId: this.outFormObject.worksheetId, outFormId: this.outFormObject.outFormId } })
						} else {
							// if (history.replaceState) {
							// 	history.replaceState(null, document.title, successResult.url)
							// 	history.go(0)
							// } else {
							// 	window.location.replace(successResult.url)
							// }
							window.location.replace(successResult.url)
							// window.location.replace(successResult.url)
							// window.location.href = successResult.url
							// window.open(successResult.url, '_blank')
						}
					}
				}
			}).catch((e) => {
				console.log(e)
			})
			// this.$router.push({ path: '/qrcode' })
		}
	}
